import classNames from "classnames";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft, ChevronRight } from "lucide-react";
import { resolveNavbarBreadcrumbs } from "./resolve";

import {
  BreadcrumbsContainer,
  BackButton,
  CrumbSeparator,
  CrumbTitle,
  CrumbText,
} from "./Breadcrumbs.styles";
import { breadcrumbDetailNameSelect } from "Layout/slice/selector";
import { loggedInState } from "features/Auth/slice/selector";

export const Breadcrumbs = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const detailName = useSelector(breadcrumbDetailNameSelect);
  const isLoggedInState = useSelector(loggedInState);

  const builderType = useMemo(
    () => new URLSearchParams(location.search).get("builderType"),
    [location.search]
  );

  const { crumbs } = useMemo(
    () =>
      resolveNavbarBreadcrumbs(location.pathname, {
        builderType,
        detailName,
      }),
    [location.pathname, builderType, detailName]
  );

  const isNCB = useMemo(
    () => location.pathname.includes("ncb"),
    [location.pathname]
  );

  const showBack = crumbs.length > 1;

  const handleBack = () => navigate(-1);

  const handleCrumbClick = (path) => {
    if (path) navigate(path);
  };

  return (
    <BreadcrumbsContainer
      className={classNames("nav-title", {
        "title-text": crumbs.length > 1,
      })}
    >
      {showBack && isLoggedInState && (
        <BackButton className="back-btn" onClick={handleBack}>
          <ArrowLeft size={16} color="#535862" />
        </BackButton>
      )}

      {isLoggedInState && (
        <div className="title-wrapper">
          {crumbs.map((crumb, idx) => {
            const isFirst = idx === 0;
            const isLast = idx === crumbs.length - 1;

            if (isFirst) {
              return (
                <CrumbTitle
                  key="crumb-first"
                  isLast={isLast}
                  className={classNames({ hide: isNCB })}
                  onClick={() => handleCrumbClick(crumb.path)}
                >
                  {crumb.icon}
                  {crumb.label}
                </CrumbTitle>
              );
            }

            return (
              <span key={`crumb-${idx}`} className="crumb">
                <CrumbSeparator>
                  <ChevronRight size={16} strokeWidth={2} />
                </CrumbSeparator>
                <CrumbText
                  isLast={isLast}
                  className={classNames({ last: isLast })}
                >
                  {crumb.label}
                </CrumbText>
              </span>
            );
          })}
        </div>
      )}
    </BreadcrumbsContainer>
  );
};
